module.exports = __webpack_public_path__ + "assets/img/hope-icon.ff9fa308.png";